import { gql } from 'graphql-request'

export const GET_USER_COMMENT_NOTIFICATION = gql`
  query GetUserCommentNotification(
    $commentNotificationType: CommentNotificationType!
    $bookId: Float
    $page: Int
    $limitPerPage: Int
    $bookType: BookType
  ) {
    getUserCommentNotification(
      commentNotificationType: $commentNotificationType
      bookId: $bookId
      page: $page
      limitPerPage: $limitPerPage
      bookType: $bookType
    ) {
      data {
        id
        content
        childrenComment {
          id
          content
          likeCount
          isLiked
          replied {
            user {
              id
            }
            id
          }
          user {
            id
            displayName
            avatarImgPath
            profilePageSlug
          }
          visible
          createdAt
          parentComment {
            user {
              id
              profilePageSlug
            }
          }
          updatedBy {
            id
          }
        }
        isLiked
        likeCount
        user {
          id
          displayName
          avatarImgPath
          profilePageSlug
        }
        bookChapter {
          chapterName
        }
        visible
        createdAt
        updatedBy {
          id
        }
        book {
          id
          title
          penName {
            user {
              id
            }
          }
          guestCommentable
          commentable
          isUserHasBlockedComment
        }
      }
      total
      page
    }
  }
`
